<section>
	<header class="row page-header margin-0">
		<div class="container">
			<div class="row">
				<div class="col-md-12">
					<h2 class=title>SIGN IN</h2>
					<p class="hint">Sign in to your SmartProperty account.</p>
				</div>
			</div>
            <div class="row">
                <div class="col-md-12">
                    <sp-comm-state #signInCommState [successMessage]="''" [failedMessage]="'Sign in failed'" [scrollOnStateChange]="true" [scrollItemSelector]="'body'"></sp-comm-state>
                    <sp-comm-state #checkResetPwdCommState [successMessage]="''" [scrollOnStateChange]="true" [scrollItemSelector]="'body'"></sp-comm-state>
                </div>
            </div>
		</div>
	</header>

	<main>
		<form [formGroup]="signInForm">
			<div class="form-section">
				<div class="container">
					<div class="form-section-container">
						<div class="row top-buffer-20">
							<div class="col-md-2">
								<label for="email">Email</label>
							</div>
							<div class="col-md-5">
								<input id="email" data-testid="signin-email-input" type="email" class="form-control" formControlName="email" placeholder="Email" maxlength="100" required />
								<sp-field-error [controlName]="'Email'" [control]="signInForm?.controls?.email"></sp-field-error>
							</div>
						</div>
						<div class="row top-buffer-20">
							<div class="col-md-2">
								<label for="password">Password</label>
							</div>
							<div class="col-md-5">
								<input id="password" data-testid="signin-password-input" type="password" class="form-control" formControlName="password" placeholder="Password" maxlength="20" required />
								<sp-field-error [controlName]="'Password'" [control]="signInForm?.controls?.password"></sp-field-error>
							</div>
						</div>
						<div class="row top-buffer-20">
							<div class="col-md-5 offset-md-2">
							  <button [disabled]="!signInForm?.valid || isSubmitting" type="submit" (click)="onSignIn()" class="btn btn-success"
							          [ngClass]="{'small-pad': isSubmitting }"
									  data-testid="signin-button">
							    <span *ngIf="isSubmitting" class="sp-icon-loader-button-secondary u-alignMiddle"></span>{{isSubmitting? 'Signing In...': 'Sign In'}}
							  </button>
							</div>
							<div class="col-md-4">
							  <label>
							      <!--
							      <button type="button"
							              [disabled]="!signInForm?.controls?.email?.valid || isRequestingResetPwd || isSubmitting"
							              class="reset-button"
							              (click)="onSubmitResetPasswordRequest()">
							      <span *ngIf="isRequestingResetPwd" class="sp-icon-loader-small-button-primary u-alignMiddle"></span>
							      Send an email to reset your password
							      -->
							      <!-- [routerLink]="['/resetpassword']" -->
							      <a  (click)="onSubmitResetPasswordRequest()"  class="reset-button">Can't log in?</a>
							  </label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	</main>
</section>
